import { Paper, Typography } from "@mui/material";
import { colors } from "../constants/designTokens";
import { intersecaoNoticeStyles } from "../utils/intersecaoEmpreendimentos";

export default function EmpreendimentosIntersecaoNotice({
  isTodosEmpreendimentos,
  activeMonth,
  empreendimentos = [],
}) {
  if (!isTodosEmpreendimentos || !activeMonth || !empreendimentos.length) {
    return null;
  }

  return (
    <Paper elevation={0} sx={intersecaoNoticeStyles}>
      <Typography sx={{ color: colors.muted, fontSize: 13 }}>
        Participacao Mensal de Todos Empreendimentos em{" "}
        <strong style={{ color: colors.text }}>{activeMonth}</strong> entre:{" "}
        <strong style={{ color: colors.text }}>
          {empreendimentos.map((item) => item.nomeEmpresa || item.nomeObra).join(", ")}
        </strong>
      </Typography>
    </Paper>
  );
}
